import { CalendarEvent } from 'mini-calendar-event-types';
import { isItemSenderTheMeetingAttendee } from 'mini-meeting-invite/lib/utils/isItemSenderTheMeetingAttendee';
import { MiniIcons } from 'owa-mini-icons';

export interface RsvpUnitIconDetails {
    icon: string;
    iconStyles: string;
    iconContainerStyles: string;
    badge: string;
}

const styles = require('../components/RsvpUnit.scss');
const classNames = require('classnames/bind').bind(styles);

/**
 * Given an item, icon and its styles
 * @param item
 */
export const getRsvpUnitIcon = (item: CalendarEvent): RsvpUnitIconDetails => {
    // Get the subtitle
    let icon: MiniIcons;
    let iconContainerStyles: string;
    let iconStyles: string;
    let badge: string;

    if (isItemSenderTheMeetingAttendee(item as any)) {
        if (item.ResponseType === 'Accept') {
            // Accepted scenario
            icon = MiniIcons.Event;
            iconContainerStyles = styles.iconContainer;
            iconStyles = styles.iconStyles;
            badge = MiniIcons.Accept;
        } else if (item.ResponseType === 'Tentative') {
            // Tentative scenario
            icon = MiniIcons.Event;
            iconContainerStyles = styles.iconContainer;
            iconStyles = styles.iconStyles;
            badge = MiniIcons.Help;
        } else if (item.ResponseType === 'Decline') {
            // Declined scenario
            icon = MiniIcons.Event;
            iconContainerStyles = styles.iconContainer;
            iconStyles = styles.iconStyles;
            badge = MiniIcons.Cancel;
        }

        if (badge) {
            // means we have a response
            return { icon, iconContainerStyles, iconStyles, badge };
        }
    }

    if (item.IsSeriesCancelled || (item.IsCancelled && item.isSeriesMaster?.())) {
        // A cancelled series
        icon = MiniIcons.RemoveEvent;
        iconContainerStyles = classNames(styles.iconContainer, styles.isCancelled);
        iconStyles = styles.iconStyles;
    } else if (item.isSeriesInstance?.() && item.IsCancelled) {
        // A cancelled instance of a series
        icon = MiniIcons.RemoveEvent;
        iconContainerStyles = classNames(styles.iconContainer, styles.isCancelled);
        iconStyles = styles.iconStyles;
    } else if (item.IsCancelled && !item.IsRecurring) {
        // A cancelled normal event
        icon = MiniIcons.RemoveEvent;
        iconContainerStyles = classNames(styles.iconContainer, styles.isCancelled);
        iconStyles = styles.iconStyles;
    } else if (item.IsRecurring) {
        // Recurring meeting sent to attendee
        icon = MiniIcons.RecurringEvent;
        iconStyles = styles.iconStyles;
        iconContainerStyles = styles.iconContainer;
    } else if (!item.ActualConflictingMeetingCount) {
        // Normal event without conflicts
        icon = MiniIcons.Event;
        iconStyles = styles.iconStyles;
        iconContainerStyles = styles.iconContainer;
    } else if (item.ActualConflictingMeetingCount) {
        // Event with conflicts
        icon = MiniIcons.EventDateMissed12;
        iconStyles = classNames(styles.iconStyles, styles.isConflicting);
        iconContainerStyles = styles.iconContainer;
    }

    return { icon, iconContainerStyles, iconStyles, badge };
};
